import {UIGameManager} from '../UIGameManager'
import {UIGameActionButtonView} from './UIGameActionButtonView'
import {PIXI} from '@colonist/pixi'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {PlayerColor} from '@colonist/game-states'

export abstract class UIGameActionButtonMultiView extends UIGameActionButtonView implements UIGameMechanic {
    protected readonly expandedButtons: UIGameActionButtonView[]
    private lastPlayerTurn: PlayerColor

    constructor(uiGameManager: UIGameManager, preferredPosition: number, container: PIXI.Container) {
        super(uiGameManager, preferredPosition, container)

        this.expandedButtons = []
        this.setUpdateAction()
        this.repositionedButton = () => {
            this.repositionButtons()
        }
        this.checkAndUpdateOpacityIfExpandedButtonsAreActive()
    }

    buttonSpecificEvents(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.PlayerControllerStateUpdated:
            case UIGameEventEnums.CityImprovementStateUpdated: this.checkAndUpdateOpacityIfExpandedButtonsAreActive(); break
            case UIGameEventEnums.GameStateUpdated:
                this.closeButtonAtEndOfMyTurn()
                this.checkAndUpdateOpacityIfExpandedButtonsAreActive()
                this.lastPlayerTurn = this.uiGameManager.gameController.currentState.currentTurnPlayerColor
                break
            case UIGameEventEnums.ClickedMultiButton: this.hideButtons(); break
            case UIGameEventEnums.ShowTradeUI: this.hideButtons(); break
            default: break
        }
    }

    addButton(newActionButton: UIGameActionButtonView) {
        this.expandedButtons.push(newActionButton)
        if(newActionButton.parent != undefined) newActionButton.parent.removeChild(newActionButton)
    }

    protected abstract repositionButtons()

    private setUpdateAction() {
        this.repositionButtons()
        this.updateAction(() => {
            this.toggleShowButtonViews()
        })
    }

    private toggleShowButtonViews() {
        if(this.expandedButtons.length <= 0) return
        const areButtonsAlreadyShown = this.expandedButtons[0].parent != undefined
        this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.ClickedMultiButton)
        areButtonsAlreadyShown ? this.hideButtons() : this.showButtons()
    }

    private hideButtons() {
        for(const button of this.expandedButtons) {
            if(button.parent == undefined) continue
            button.parent.removeChild(button)
            button.removeCardHover()
        }
    }

    private showButtons() {
        for(const button of this.expandedButtons) {
            if(button.parent != undefined) continue
            this.uiGameManager.actionsController.container.addChild(button)
        }
    }

    forceShowButtons() {
        this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.ClickedMultiButton)
        this.showButtons()
    }

    checkAndUpdateOpacityIfExpandedButtonsAreActive() {
        this.inactivateOpacity()
        if(!this.uiGameManager.gameController.isMyTurn) return
        for(const expandedButton of this.expandedButtons) {
            if(!expandedButton.isButtonOpactityActive()) continue

            this.activateOpacity()
            return
        }
    }

    private closeButtonAtEndOfMyTurn() {
        if(this.lastPlayerTurn != this.uiGameManager.gameController.myColor) return
        if(this.uiGameManager.gameController.isMyTurn && this.uiGameManager.gameController.diceState.diceThrown) return
        this.hideButtons()
    }
}
